import { Component } from 'react'
import Panel from 'components/Panel'
import { connect } from 'react-redux'
import { selectLocation } from 'containers/App/selectors'
import { OptionsHOC } from '../../hocs'
import { addMessageListener } from 'helpers/utils'
import Preview from './Preview'
import { Row, Col } from 'react-bootstrap'
import { triggerWindowEvent } from 'helpers/utils'

class VirtualAgent extends Component {
  state = {
    previewUrl: null
  }
  componentDidMount() {
    const { getOption } = this.props
    const id = getOption('virtualAgent.id')
    const apiUrl = getOption('virtualAgent.apiUrl')
    const bundle = getOption('virtualAgent.bundle')
    const actionLog = getOption('virtualAgent.actionLog')
    const backend = getOption('virtualAgent.backend', 'botapi')

    if (!id) {
      return
    }

    loadScript(bundle, () => {
      DbChatWidget.init({
        backend,
        botId: id,
        embedded: true,
        apiUrl: apiUrl,
        actionLog: actionLog
      })
    })

    this.registerEventListener()
  }

  get showPreview() {
    const { previewUrl } = this.state
    return previewUrl && previewUrl !== '/'
  }

  // Listen for dbNav events, show preview in iframe when received
  registerEventListener = () => {
    addMessageListener('dbNav', (data) => {
      this.setState({ previewUrl: data.value })
      // Needed for bot to recalculate card sliders width after preview is displayed
      triggerWindowEvent('resize')
    })
  }

  closePreview = () => {
    this.setState({ previewUrl: '' })
    // Needed for bot to recalculate card sliders width after preview is displayed
    triggerWindowEvent('resize')
  }

  render() {
    const { location, getOption } = this.props
    const { previewUrl } = this.state
    if (!getOption('virtualAgent.id')) {
      return null
    }

    return (
      <div style={{ display: location === '/' ? 'block' : 'none' }}>
        <Panel title="Virtual Agent" blue padding="0">
          <Row style={{ display: 'flex' }}>
            <Col xs={this.showPreview ? 4 : 12}>
              <div
                id="db-chat-widget-root"
                style={{ height: 'calc(100vh - 200px)', position: 'relative' }}
              />
            </Col>
            {this.showPreview && (
              <Col xs={8}>
                <Preview url={previewUrl} close={this.closePreview} />
              </Col>
            )}
          </Row>
        </Panel>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  location: selectLocation(state)
})

export default connect(mapStateToProps, null)(OptionsHOC(VirtualAgent))
